import { render, staticRenderFns } from "./AlertModal.vue?vue&type=template&id=56b2013f&scoped=true&"
import script from "./AlertModal.vue?vue&type=script&lang=js&"
export * from "./AlertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b2013f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b2013f')) {
      api.createRecord('56b2013f', component.options)
    } else {
      api.reload('56b2013f', component.options)
    }
    module.hot.accept("./AlertModal.vue?vue&type=template&id=56b2013f&scoped=true&", function () {
      api.rerender('56b2013f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Modals/AlertModal.vue"
export default component.exports